import React from 'react';

interface GlowBackgroundProps {
  color: string;
}

export const GlowBackground: React.FC<GlowBackgroundProps> = ({ color }) => (
  <div
    style={{
      position: 'absolute',
      width: '80%',
      aspectRatio: '1',
      top: -100,
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: color,
      opacity: 0.25,
      filter: 'blur(100px)',
      borderRadius: '50%',
      zIndex: 0,
    }}
  />
);
